module.exports = new __parcel__URL__("cat-animal-icon.2cb08d7b.svg").toString();